import React from "react";
import { useMasterValues } from "../../components/common/MasterData";
import RoleRoutes from "../RoleRoutes";
import ProjectsDropDown from "../../components/layout/CrmProject";
import { useProjectValues } from "../../components/common/ProjectData";
import { useEffect } from "react";

export const pathName = "/crm-executives";

export const paths = {
  crm: "/crm",
  sales: "/sales",
  Apartment: "/src/components/sales-manager/availability/ApartmentModal.js",
  booking: "../sales-manager/BookingDetails.js",
  costSheet: "../sales-manager/CostSheet.js",
  dashboard: "/dashboard",
  legal_documents: "/legal_documents",
  reports: "/reports",
  digital_approval: "/digital_approval",
  customerDelight: "/CustomerDelight",
  apartmentHandover: "/apartmentHandover",
  landownerreport: "/landownerreport",
};

export const landing = `${pathName}${paths.dashboard}`;
export const sales = `${pathName}${paths.sales}`;
export const crm = `${pathName}${paths.crm}`;
export const legal_documents = `${pathName}${paths.legal_documents}`;
export const reports = `${pathName}${paths.reports}`;
export const digital_approval = `${pathName}${paths.digital_approval}`;
export const customerDelight = `${pathName}${paths.customerDelight}`;
export const apartmentHandover = `${pathName}${paths.apartmentHandover}`;
export const landownerreport = `${pathName}${paths.landownerreport}`;

const CRMWrapper = ({ routes, landing, allowRoles }) => {
  const [fetching, data] = useMasterValues();
  const { crm_project } = useProjectValues();
  
  const project = crm_project?.id

  useEffect(() => {
    console.log("=== Master Values Loaded ===");
    console.log("Fetching:", fetching);
    console.log("Data:", data);
    console.log("CRM PROJECT:", crm_project);
  }, [fetching, data, crm_project]);

  const getMenu = () => {
    const menu = [
      { title: "Dashboard", to: landing },
      { title: "Sales", to: sales },
      { title: "CRM", to: crm },
      { title: "Digital Approval", to: digital_approval },
      { title: "Legal Module", to: legal_documents },
      { title: "Reports", to: reports },
      { title: "Customer Delight", to: customerDelight },
      { title: project === 19 ? "Plot Handover" : "Apartment Handover", to: apartmentHandover },

      crm_project?.id === 6
        ? { title: "Landowner Report", to: landownerreport }
        : null,
    ];

    return menu.filter(Boolean);
  };

  return (
    <RoleRoutes
      title="CRM - Executives"
      routes={routes}
      menu={getMenu()}
      landing={landing}
      allowRoles={allowRoles}
      crm_project={crm_project}
      headerRight={<ProjectsDropDown projectData={data} />}
    />
  );
};

export default CRMWrapper;
